import { handleAxiosError } from 'core/notifications';

import axios from '@/util/axios';

export default async ({ id }) => {
  try {
    await axios.post('/api/learner/waitlist_items', { data: { course_session_id: id } });
  } catch (error) {
    handleAxiosError(error);
  }
};
